import { deleteRequest, getRequest, postRequest, putRequest } from "../../apiClient";
import { CompaniesEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetCompanies = async (queryString: any) => {
    var _url = CompaniesEndpoint.COMPANIES_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetPublicCompanies = async (queryString: any) => {
    var _url = CompaniesEndpoint.COMPANIES_PUBLIC_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetCompanyById = async (companyId: string | number) => {
    var _url = CompaniesEndpoint.COMPANY_BY_ID_URL(companyId);
    var res = await getRequest(_url);

    return res;
};

export const GetCompanyUsers = async (companyId: string | number, queryString: any) => {
    var _url = CompaniesEndpoint.COMPANY_USERS_URL(companyId) + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetCompanyLicenseHistories = async (companyId: string | number, queryString: any) => {
    var _url = CompaniesEndpoint.COMPANY_LICENSE_HISTORY_BY_COMPANY_ID_URL(companyId) + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetCompanyByRegistrationCode = async (registrationCode: string | number) => {
    var _url = CompaniesEndpoint.COMPANY_BY_REGISTRATION_CODE_URL(registrationCode);
    var res = await getRequest(_url);

    return res;
};

export const GetCompanyByVendorRegistrationCode = async (vendorRegistrationCode: string | number) => {
    var _url = CompaniesEndpoint.COMPANY_BY_VENDOR_REGISTRATION_CODE_URL(vendorRegistrationCode);
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const CreateCompanyService = async (param: any) => {
    var res = await postRequest(CompaniesEndpoint.COMPANIES_URL, param);

    return res;
};
export const CreateCompanyUserService = async (companyId: string | number,param: any) => {
    var res = await postRequest(CompaniesEndpoint.COMPANY_USERS_URL(companyId), param);

    return res;
};

export const GenerateCompanyDatabaseService = async (companyId: string | number) => {
    var res = await postRequest(CompaniesEndpoint.COMPANY_GENERATE_DATABASE_BY_ID_URL(companyId));

    return res;
};

export const SyncCompanyUserService = async (companyId: string | number, param: any) => {
    var res = await postRequest(CompaniesEndpoint.COMPANY_SYNC_USERS(companyId), param);

    return res;
};

//#region----------------- PUT-----------------------
export const EditCompanyService = async (id: string | number, param: any) => {
    var res = await putRequest(CompaniesEndpoint.COMPANY_BY_ID_URL(id), param);

    return res;
};
export const EditCompanyUserService = async (companyId: string | number, userId: string | number, param: any) => {
    var res = await putRequest(CompaniesEndpoint.COMPANY_USER_BY_ID_URL(companyId, userId), param);

    return res;
};
//#endregion

//#region----------------- DELETE-----------------------
export const DeleteCompanyService = async (id: string | number, param: any) => {
    var _url = CompaniesEndpoint.COMPANY_DELETE_BY_ID_URL(id);
    var res = await postRequest(_url, param);

    return res;
};
export const DeleteCompanyUserService = async (companyId: string | number, userId: string | number) => {
    var _url = CompaniesEndpoint.COMPANY_USER_BY_ID_URL(companyId, userId);
    var res = await deleteRequest(_url);

    return res;
};

//#endregion